import jQuery from "jquery";
window.$ = window.jQuery = jQuery;

$(function () {
	screenDetectTasks();

	window.addEventListener("hashchange", function () {
		history.replaceState({}, document.title, ".");
	});

	$("footer .copyright-year").text(new Date().getFullYear());

	$(".branding").on("click", function () {
		window.location = "./";
	});

	// $(".back-listing-buttons button").on("click", function () {
	// 	window.location = "./#resources";
	// });

	//Buying Options
	// $(".btn-buy-now, .item-title a").on("click", function (e) {
	// 	e.preventDefault();
	// 	$(
	// 		".buying-options .buy-wileycom, .buying-options .buy-others-listing a"
	// 	).attr("href", "");
	// 	$(
	// 		".buying-options .buy-wileycom-type, .buying-options .buy-wileycom-title"
	// 	).text("");
	// 	$(".buying-options").fadeIn().css("display", "flex");
	// 	$(".buying-options .buy-wileycom").attr("href", $(this).data("wiley"));
	// 	$(".buying-options .buy-wileycom-type").html(
	// 		$(this).data("type") + " via <b>Wiley.com</b>"
	// 	);
	// 	$(".buying-options .buy-wileycom-title").text($(this).data("title"));
	// 	$(".buying-options .buy-amazon").attr("href", $(this).data("amazon"));
	// 	$(".buying-options .buy-walmart").attr("href", $(this).data("walmart"));
	// 	$(".buying-options .buy-indigo").attr("href", $(this).data("indigo"));
	// 	$(".buying-options .buy-barnes").attr("href", $(this).data("barnes"));
	// 	$(".buying-options .buy-bam").attr("href", $(this).data("bam"));
	// 	$(".buying-options .buy-bookshop").attr("href", $(this).data("bookshop"));
	// });
	// $(".modal-close").on("click", function () {
	// 	$(".buying-options").fadeOut();
	// });
	//Mobile Menu
	if ($("body").hasClass("mobile")) {
		$(".mobile-menu").siblings("nav").hide();
	}
	$(".mobile-menu .close").hide();
	$(".mobile-menu").on("click", function () {
		$(this).siblings("nav").fadeToggle(200, "swing");
		$(".mobile-menu .close, .mobile-menu .open").toggle();
	});
	$(".navbar nav a").on("click", function () {
		if ($("body").hasClass("mobile")) {
			$(this).parent("nav").hide();
			$(".mobile-menu .close, .mobile-menu .open").toggle();
		}
	});

	//Modal Window
	// function openModal() {
	// 	$(".modal").fadeIn().css("display", "flex");
	// 	$("html, body").addClass("no-scroll");
	// }
	// function closeModal() {
	// 	$(".modal").fadeOut();
	// 	$("html, body").removeClass("no-scroll");
	// }
	// $("[data-modal]").on("click", function (e) {
	// 	e.preventDefault();
	// 	openModal();
	// 	let page = $(this).attr("href");
	// 	if (page !== "#") {
	// 		$(".modal .modal-body").load(page);
	// 	}
	// });
	// $(".modal .modal-close").on("click", function () {
	// 	closeModal();
	// 	$(".modal .modal-body").load("");
	// });
	// $(document).on("keydown", function (event) {
	// 	if (event.key == "Escape") {
	// 		closeModal();
	// 	}
	// });
	//Get the button
	var backTopButton = document.getElementById("back_top");
	// When the user scrolls down 1000px from the top of the document, show the button
	window.onscroll = function () {
		scrollFunction();
	};
	function scrollFunction() {
		if (
			document.body.scrollTop > 1000 ||
			document.documentElement.scrollTop > 1000
		) {
			backTopButton.style.display = "block";
		} else {
			backTopButton.style.display = "none";
		}
	}
	// When the user clicks on the button, scroll to the top of the document
	function topFunction() {
		document.body.scrollTop = 0;
		document.documentElement.scrollTop = 0;
	}

	//Social Media Sharing Widgets
	var shareTitle = encodeURI(document.title);
	var shareExcerpt = encodeURI($('meta[name="description"]').text());
	var shareUrl = encodeURI(window.location.href);
	var shareThumbnail =
		shareUrl + encodeURI($(".blog-featured-image img").attr("src"));
	// The magic starts here:
	$("[data-media=facebook]").attr(
		"href",
		"https://www.facebook.com/sharer.php?u=" + shareUrl
	);
	$("[data-media=linkedin]").attr(
		"href",
		"https://www.linkedin.com/shareArticle?url=" +
			shareUrl +
			"&title=" +
			shareTitle
	);
	$("[data-media=twitter]").attr(
		"href",
		"https://twitter.com/share?url=" + shareUrl + "&text=" + shareTitle
	);
	$("[data-media=whatsapp]").attr(
		"href",
		"https://api.whatsapp.com/send?text=" + shareTitle + "%20" + shareUrl
	);
	$("[data-media=telegram]").attr(
		"href",
		"https://telegram.me/share/url?url=" + shareUrl + "&text=" + shareTitle
	);
	$("[data-media=pinterest]").attr(
		"href",
		"https://pinterest.com/pin/create/bookmarklet/?media=" +
			shareThumbnail +
			"&url=" +
			shareUrl +
			"&description=" +
			shareTitle
	);
	$("[data-media=reddit]").attr(
		"href",
		"https://reddit.com/submit?url=" + shareUrl + "&title=" + shareTitle
	);
	$("[data-media=weibo]").attr(
		"href",
		"https://service.weibo.com/share/share.php?url=" +
			shareUrl +
			"&title=" +
			shareTitle
	);
	$("[data-media=email]").attr(
		"href",
		"mailto:?subject=" + shareTitle + "&body=" + shareUrl + "%20" + shareExcerpt
	);

	$(".blog-listing .category-buttons button").on("click", function () {
		$(".blog-listing .category-buttons button").removeClass("active");
		$(".nothing-found").hide();
		$(this).addClass("active");
		var sortValue = $(this).data("sort");
		showSortListing(sortValue);
	});
}); //Document Ready
function showSortListing(sortValue) {
	$(".blog-listing .blog-list .list-item").hide();
	if (sortValue == "all") {
		$(".blog-listing .blog-list .list-item").fadeIn();
	} else {
		$(".blog-listing .blog-list .list-item").each(function () {
			if ($(this).hasClass(sortValue)) {
				$(this).fadeIn();
			}
		});
	}
	if ($(".blog-listing .blog-list .list-item:visible").length == 0) {
		console.log("No Items Found");
		$(".nothing-found").fadeIn();
	}
}
function screenDetectTasks() {
	// viewport and full window dimensions will change
	let viewport_width = window.innerWidth;
	let bodyElement = document.querySelector("body");
	// console.log(viewport_width);
	if (viewport_width <= 428) {
		//Is Mobile
		bodyElement.classList.add("mobile");
	}

	if (viewport_width > 429 && viewport_width <= 991) {
		//Is Tablet
		bodyElement.classList.add("tablet");
	}

	if (viewport_width >= 992) {
		//Is Desktop
		bodyElement.classList.add("desktop");
	}
}
